import { types } from 'mobx-state-tree';
import Token from './Token';

const PaymentTokens = types.model('PaymentTokens', {
  creation_url: types.maybeNull(types.string),
  tokens: types.optional(types.array(Token), [])
});

export default PaymentTokens;



// WEBPACK FOOTER //
// ./src/models/PaymentTokens.js